import { memo, useCallback } from 'react';
import { useBoolean } from 'usehooks-ts';

import { DocumentActionItem } from '@/components/Form/ActionList/DocumentActionItem';

import { useDrawerOpenTracker } from '@/context';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectSigningDocuments } from '@/redux/user-data/selectors';

import { DocumentsSigningDrawer } from '../drawers/DocumentsSigningDrawer';

type DocumentSigningProps = {
  disabled?: boolean;
};

const DocumentSigningComponent = ({
  disabled = false,
}: DocumentSigningProps) => {
  const { t } = useTranslate();
  const { formsToSign, documentsSigningStatus, remainingDocsToSign } =
    useAppSelector(selectSigningDocuments);

  const {
    value: isDrawerVisible,
    setTrue: showDrawer,
    setFalse: hideDrawer,
  } = useBoolean(false);

  useDrawerOpenTracker(isDrawerVisible);

  const openDrawer = useCallback(() => {
    showDrawer();
  }, [showDrawer]);

  return (
    <>
      <DocumentActionItem
        title={t('moreInfo.form.docSigning.title')}
        subDescription={
          remainingDocsToSign
            ? t('moreInfo.form.docSigning.subDescription', {
                count: remainingDocsToSign,
              })
            : ''
        }
        onClick={formsToSign.length ? openDrawer : undefined}
        status={documentsSigningStatus}
        hideAction={!formsToSign.length}
        disabled={disabled}
        enabledForAllStatuses
      />
      <DocumentsSigningDrawer open={isDrawerVisible} onClose={hideDrawer} />
    </>
  );
};

export const DocumentSigning = memo(DocumentSigningComponent);
